import React, { useState } from 'react';
import loginService from '../controller/controller.login';
import NavBar from './commonHooks/commonHooks.navBar'; // Import NavBar component
import DiscSignIn from './commonHooks/commonHooks.discSignIn'
import './css/sign.css'

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSignUp = async (event) => {
        event.preventDefault();

        // Email validation using regex
        const emailRegex = /\S+@\S+\.\S+/;
        if (!emailRegex.test(email)) {
            setMessage('Invalid email address.');
            return;
        }

        try {
            const response = await loginService.signup(username, password, email);
            if (response.status) {
                setMessage('Sign-up successful!');
            } else {
                setMessage('An error occurred. Please try again.');
            }
        } catch (error) {
            if (error.response.status === 400) {
                setMessage('Username is taken. Please try again.');
            } else {
                setMessage('An error occurred. Please try again.');
            }
        }
    };

    return (
        <div className="app-container">
            <NavBar /> {/* Render NavBar */}
            <div className="signin-container">
                <form onSubmit={handleSignUp}>
                    <div className="form-group">
                        <label htmlFor="email" className="label">Email:</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="username" className="label">Username:</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="input"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="label">Password:</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input"
                            required
                        />
                    </div>
                    <button type="submit" className="login-button">Sign Up</button>
                </form>
                {message && <div className='message-box'>
                    <p>{message}</p>
                </div>}
            </div>
            <DiscSignIn />
        </div>
    );
};

export default SignUp;
